export default __webpack_public_path__ + "static/media/asymmetrical_airy.39a3142b.jpg";